import { constructFrom as o } from "./constructFrom.js";
function n(t) {
  return o(t, Date.now());
}
export {
  n as constructNow,
  n as default
};
//# sourceMappingURL=constructNow.js.map
